import React from "react";
import { useOverrides, Override } from "@quarkly/components";
import { Text, LinkBox, Box, Link, Section } from "@quarkly/widgets";
const defaultProps = {
	"padding": "160px 0 99px 0",
	"md-padding": "40px 0 50px 0",
	"background": "--color-sectionBg"
};
const overrides = {
	"box": {
		"kind": "Box",
		"props": {
			"padding": "0px 32px 0px 0px",
			"md-width": "100%",
			"empty-min-width": "64px",
			"empty-min-height": "64px",
			"empty-border-width": "1px",
			"empty-border-style": "solid",
			"empty-border-color": "LightGray",
			"width": "30%"
		}
	},
	"linkBox": {
		"kind": "LinkBox",
		"props": {
			"href": "/index"
		}
	},
	"text": {
		"kind": "Text",
		"props": {
			"font": "400 28px/1.5 --fontFamily-googleMarcellus",
			"color": "--secondary",
			"margin": "0px 0px 8px 0px",
			"align-self": "flex-start",
			"children": "Frintala Workhouse"
		}
	},
	"text1": {
		"kind": "Text",
		"props": {
			"color": "--darkL2",
			"md-margin": "0px 0px 30px 0px",
			"margin": "0px 0px 0px 0px",
			"font": "--lead",
			"children": "We’re here to help! Whether you have a question about our services, need assistance with booking, or want a customized cleaning plan, don’t hesitate to get in touch."
		}
	},
	"box1": {
		"kind": "Box",
		"props": {
			"padding": "0px 0px 0px 16px",
			"md-margin": "20px 0px 0px 0px",
			"md-width": "33.333%",
			"empty-min-height": "64px",
			"empty-border-style": "solid",
			"empty-border-color": "LightGray",
			"flex-direction": "column",
			"md-padding": "0px 0px 0px 0px",
			"empty-min-width": "64px",
			"empty-border-width": "1px",
			"width": "33%",
			"display": "flex"
		}
	},
	"text2": {
		"kind": "Text",
		"props": {
			"margin": "0px 0px 8px 0px",
			"font": "--headline3",
			"color": "--secondary",
			"children": "Navigation"
		}
	},
	"link": {
		"kind": "Link",
		"props": {
			"transition": "opacity 0.3s ease-in-out 0s",
			"hover-text-decoration-line": "initial",
			"hover-opacity": ".8",
			"color": "--coral",
			"font": "--lead",
			"text-decoration-line": "initial",
			"margin": "0px 0px 8px 0px",
			"href": "/index",
			"children": "Homepage"
		}
	},
	"link1": {
		"kind": "Link",
		"props": {
			"hover-text-decoration-line": "initial",
			"hover-opacity": ".8",
			"color": "--coral",
			"font": "--lead",
			"text-decoration-line": "initial",
			"margin": "0px 0px 8px 0px",
			"transition": "opacity 0.3s ease-in-out 0s",
			"href": "/how-to",
			"children": "Contatcs"
		}
	},
	"link2": {
		"kind": "Link",
		"props": {
			"margin": "0px 0px 8px 0px",
			"transition": "opacity 0.3s ease-in-out 0s",
			"hover-text-decoration-line": "initial",
			"hover-opacity": ".8",
			"color": "--coral",
			"font": "--lead",
			"text-decoration-line": "initial",
			"href": "/faq",
			"children": "FAQ"
		}
	},
	"link3": {
		"kind": "Link",
		"props": {
			"color": "--coral",
			"font": "--lead",
			"text-decoration-line": "initial",
			"margin": "0px 0px 8px 0px",
			"transition": "opacity 0.3s ease-in-out 0s",
			"hover-text-decoration-line": "initial",
			"hover-opacity": ".8",
			"href": "/privacy-policy",
			"children": "Privacy Policy"
		}
	},
	"link4": {
		"kind": "Link",
		"props": {
			"color": "--coral",
			"font": "--lead",
			"text-decoration-line": "initial",
			"margin": "0px 0px 8px 0px",
			"transition": "opacity 0.3s ease-in-out 0s",
			"hover-text-decoration-line": "initial",
			"hover-opacity": ".8",
			"href": "/terms-and-conditions",
			"children": "Terms and Conditions"
		}
	},
	"box2": {
		"kind": "Box",
		"props": {
			"empty-min-width": "64px",
			"empty-border-width": "1px",
			"empty-border-color": "LightGray",
			"width": "33%",
			"display": "flex",
			"md-margin": "20px 0px 0px 0px",
			"md-width": "33.333%",
			"empty-min-height": "64px",
			"empty-border-style": "solid",
			"flex-direction": "column"
		}
	},
	"text3": {
		"kind": "Text",
		"props": {
			"margin": "0px 0px 8px 0px",
			"font": "--headline3",
			"color": "--secondary",
			"children": "Contacts"
		}
	},
	"text4": {
		"kind": "Text",
		"props": {
			"color": "--darkL2",
			"font": "--base",
			"margin": "0px 0px 8px 0px",
			"children": "info@frintalaworkhouse.com"
		}
	},
	"text5": {
		"kind": "Text",
		"props": {
			"color": "--darkL2",
			"font": "--base",
			"margin": "0px 0px 8px 0px",
			"children": "61 1300 070 009"
		}
	},
	"text6": {
		"kind": "Text",
		"props": {
			"color": "--darkL2",
			"font": "--base",
			"margin": "0px 0px 8px 0px",
			"children": "Lylow Ct, Findon SA 5023"
		}
	}
};

const Footer2 = props => {
	const {
		override,
		children,
		rest
	} = useOverrides(props, overrides, defaultProps);
	return <Section {...rest}>
		<Override slot="SectionContent" flex-direction="row" md-flex-wrap="wrap" justify-content="space-between" />
		<Box {...override("box")}>
			<LinkBox {...override("linkBox")}>
				<Text {...override("text")} />
			</LinkBox>
			<Text {...override("text1")} />
		</Box>
		<Box {...override("box1")}>
			<Text {...override("text2")} />
			<Link {...override("link")} />
			<Link {...override("link1")} />
			<Link {...override("link2")} />
			<Link {...override("link3")} />
			<Link {...override("link4")} />
		</Box>
		<Box {...override("box2")}>
			<Text {...override("text3")} />
			<Text {...override("text4")} />
			<Text {...override("text5")} />
			<Text {...override("text6")} />
		</Box>
		{children}
	</Section>;
};

Object.assign(Footer2, { ...Section,
	defaultProps,
	overrides
});
export default Footer2;